/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoSquareIcon20Regular = forwardRef('InfoSquareIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M9.268 8.945a.75.75 0 1 0 0 1.5h.25v2.043H9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.482V9.695a.75.75 0 0 0-.75-.75h-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6A3.75 3.75 0 0 1 6 2.25h8A3.75 3.75 0 0 1 17.75 6v8A3.75 3.75 0 0 1 14 17.75H6A3.75 3.75 0 0 1 2.25 14V6ZM6 3.75A2.25 2.25 0 0 0 3.75 6v8A2.25 2.25 0 0 0 6 16.25h8A2.25 2.25 0 0 0 16.25 14V6A2.25 2.25 0 0 0 14 3.75H6Z" })));
});
